<script>
import PageImage from "../pages/page-image";


/**
 * Nav-bar Component
 */
export default {
  components: {
    PageImage
  },
  props: {
    album: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      singleImage: false,
    };
  },
  methods: {
    getImageFromNumPageAlbum(numPageAlbum) {
      let pageFound = null;

      for (const page in this.album.pages) {
        if (this.album.pages.hasOwnProperty(page) && this.album.pages[page].NumPageAlbum === numPageAlbum) {
          pageFound = this.album.pages[page];
          break;
        }
      }

      return pageFound;
    },
  }
};
</script>

<template>
  <b-card no-body class="mb-0">
    <b-row no-gutters class="align-items-center">
      <b-col md="6" class="p-0">
        <page-image :page="getImageFromNumPageAlbum(album.thumbnails)"></page-image>
      </b-col>
      <b-col md="6" class="p-0">
        <b-card-body
            :title="album.nom_volume !== '' ? album.nom_volume : album.titre"
            :sub-title="`# ${album.num_inventaire}`">
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</template>
